// extracted by mini-css-extract-plugin
module.exports = {"staticContainer":"RG7Fu9E-UN8A7-NzzAHhXg==","fixedContainer":"jXEdLG+YtldgE3uJAfaYaQ==","fixedContainerSpacer":"VcehWxU+cneJxLAExRYMXA=="};